import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useBackToOrigin } from '@/lib/origin';
import { canGoBackInApp, chatBackTarget, isDirectNav } from '@/mobile/useSmartBack';

/** Phone header back: to where you came from (t257u: history, so Who's in keeps its building, search and scroll), or the chat list. */
export function PhoneBack() {
  const { origin, back } = useBackToOrigin();
  const nav = useNavigate();
  const loc = useLocation();
  const target = chatBackTarget({ hasOrigin: Boolean(origin), inApp: canGoBackInApp(), direct: isDirectNav(loc.state) });
  const go = () => (target === 'origin' ? back() : target === 'history' ? nav(-1) : nav('/chat'));
  return (
    <button type="button" data-testid="conversation-back" aria-label={origin ? `Back to ${origin.label}` : target === 'history' ? 'Back' : 'Back to Chat'} onClick={go}
      className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-slate-700 active:bg-slate-100 dark:text-slate-200 dark:active:bg-slate-800"><ChevronLeft className="h-6 w-6" /></button>
  );
}
